export default __webpack_public_path__ + "static/media/payswitch-logo-white.8f65834d.png";